function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.24 17.4C39.16 8.14 31.08 4 24 4C24 4 24 4 23.98 4C16.92 4 8.85999 8.14 6.75999 17.38C4.39999 27.7 10.72 36.44 16.44 41.96C18.56 44 21.28 45.02 24 45.02C26.72 45.02 29.44 44 31.54 41.96C37.26 36.44 43.58 27.72 41.24 17.4Z",
    fill: "#8CD57C",
    style: {
      fill: "#8CD57C",
      fill: "color(display-p3 0.5490 0.8353 0.4863)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 22.5H18",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 16.5V28.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.3a0b12c5d5199d5956ea4a1a62648f45.svg";
export { ForwardRef as ReactComponent };